import { render, staticRenderFns } from "./staffroyaltymonth.vue?vue&type=template&id=09903bec&scoped=true&"
import script from "./staffroyaltymonth.vue?vue&type=script&lang=js&"
export * from "./staffroyaltymonth.vue?vue&type=script&lang=js&"
import style0 from "./staffroyaltymonth.vue?vue&type=style&index=0&id=09903bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09903bec",
  null
  
)

export default component.exports